module.exports = __webpack_public_path__ + "img/PDF.81150403.png";